import React, { useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import "./loan-calculator.css";

const LoanCalculator = () => {
  const [amount, setAmount] = useState(5000);
  const [days, setDays] = useState(7);
  const [rate, setRate] = useState(30);

  const interest = (amount * rate * days) / (100 * 365);
  const total = amount + interest;

  const data = [
    { name: "Loan Amount", value: amount },
    { name: "Number of Days", value: days * 10 },
    { name: "Interest Rate", value: interest },
  ];

  const COLORS = ["#4eb94a", "#ead666", "#11362b"];

  return (
    <section className="loan-calc__section">
      <div className="container loan-calc__container">
        {/* Title */}
        <div className="text-center mb-5">
          <h2 className="loan-calc__title">Loan Calculator</h2>
          <p className="loan-calc__subtitle">
            Adjust your amount, tenure, and interest rate to see your total repayment.
          </p>
        </div>

        <div className="loan-calc__sliders">
          {/* Slider 1 */}
          <div className="loan-calc__slider-box">
            <label>Loan Amount: ₹{amount}</label>
            <input
              type="range"
              min="5000"
              max="100000"
              step="1000"
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
            />
            <p className="loan-calc__value">₹{amount}</p>
          </div>

          {/* Slider 2 */}
          <div className="loan-calc__slider-box">
            <label>Number of Days: {days}</label>
            <input
              type="range"
              min="7"
              max="365"
              value={days}
              onChange={(e) => setDays(Number(e.target.value))}
            />
            <p className="loan-calc__value">{days} Days</p>
          </div>

          {/* Slider 3 */}
          <div className="loan-calc__slider-box">
            <label>Interest Rate: {rate}%</label>
            <input
              type="range"
              min="0.5"
              max="30"
              step="0.5"
              value={rate}
              onChange={(e) => setRate(Number(e.target.value))}
            />
            <p className="loan-calc__value">{rate}%</p>
          </div>
        </div>

        {/* Chart and Info */}
        <div className="loan-calc__results">
          {/* Pie Chart */}
          <div className="loan-calc__chart-box">
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={100}
                  paddingAngle={4}
                  dataKey="value"
                >
                  {data.map((entry, index) => (
                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend verticalAlign="bottom" height={36} />
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* Loan Info */}
          <div className="loan-calc__details">
            <p>Loan Amount: <span>₹{amount}</span></p>
            <p>Tenure: <span>{days} Days</span></p>
            <p>Interest Rate: <span>{rate}%</span></p>
            <p>Total Payable: <span>₹{total.toFixed(2)}</span></p>
          </div>

          {/* Additional Info */}
          <div className="loan-calc__rates-box">
            <h4>Rates and Charges</h4>
            <ul>
              <li>Loan Amount: ₹5,000 – ₹1,00,000</li>
              <li>Tenure: 7 to 365 Days</li>
              <li>No Pre-closure Charges</li>
              <li>No Prepayment Charges</li>
              <li>APR: 15% – 35%</li>
              <li>Net Salary ≥ ₹40,000</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoanCalculator;
